import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { AlertController, LoadingController } from '@ionic/angular';
import { BaseComponent } from 'src/app/base/base.component';
import { PagesToNavigateService } from 'src/app/base/pages.service';
import { SearchEnrollmentDto } from 'src/app/data/repositories/search/dto/search-enrollment.dto';
import { SearchState } from 'src/app/data/states/search.state';
import { TypePersonUpdate } from 'src/app/domain/model/TypePersonUpdate';
import { Operation } from 'src/app/domain/model/common/operation-response';
import { SearchEnrollmentUseCase } from 'src/app/domain/usecases/search/search-enrollment.usecase';
import { UpdatePersonUseCase } from 'src/app/domain/usecases/update-person/update-person-enrollment.usecase';
import { AuthService } from 'src/app/guards/auth.service';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-result-search-enrollment',
  templateUrl: './result-search-enrollment.component.html',
  styleUrls: ['./result-search-enrollment.component.scss'],
})
export class ResultSearchEnrollmentComponent extends BaseComponent implements OnInit {
  private resultForm: FormGroup;
  private enrollmentCheckedBox: boolean
  private searchEnrollmentDto: SearchEnrollmentDto

  constructor(
    private formBuilder: FormBuilder,
    private searchState: SearchState,
    protected loadingCtrl: LoadingController,
    protected router: Router,
    protected storageService: StorageService,
    protected alertController: AlertController,
    private updatePersonUseCase: UpdatePersonUseCase,
    private searchEnrollmentUseCase: SearchEnrollmentUseCase,
    protected authService: AuthService,
    protected pagesToNavigateService: PagesToNavigateService,
  ) {
    super(loadingCtrl, router, storageService, alertController, authService, pagesToNavigateService);
  }

  ngOnInit() {
    this.initSearchFormGroup();
    this.initSubscriptions();
  }

  private initSubscriptions(): void {
    this.searchState.$value.subscribe((val) => {
      this.setDataFormGroup(val);
      this.searchEnrollmentDto = val
    });
  }

  private initSearchFormGroup() {
    this.resultForm = this.formBuilder.group({
      name: [{ value: '', disabled: false }],
      email: [{ value: '', disabled: false }],
      curp: [{ value: '', disabled: false }],
      rfc: [{ value: '', disabled: false }],
      birthDay: [{ value: '', disabled: false }],
      agent: [{ value: '', disabled: false }],
      sucursal: [{ value: '', disabled: false }],
      status: [{ value: '', disabled: false }],    
      enrollmentCheck: [{ disabled: true }],
    });
  }

  private setDataFormGroup(resultSearch: SearchEnrollmentDto) {
    this.resultForm.get('name').setValue(resultSearch.name, { emitEvent: false });
    this.resultForm.get('email').setValue(resultSearch.email, { emitEvent: false });
    this.resultForm.get('curp').setValue(resultSearch.curp, { emitEvent: false });
    this.resultForm.get('rfc').setValue(resultSearch.rfc, { emitEvent: false });
    this.resultForm.get('birthDay').setValue(resultSearch.birthDay, { emitEvent: false });
    this.resultForm.get('agent').setValue(resultSearch.agent, { emitEvent: false });
    this.resultForm.get('sucursal').setValue(resultSearch.sucursal, { emitEvent: false });
    this.enrollmentCheckedBox = this.onEnrollmentValidated(resultSearch.operationStatus);
  }

  private onEnrollmentValidated(operations: Operation[]): boolean {
    var filteredOperation = this.filterOperations(operations);

    return filteredOperation
      && filteredOperation.secuenceId == 15
      && filteredOperation.activityStatus == "FINALIZADO"
      && filteredOperation.code == "VALIDATED"
  }

  private filterOperations(operations: Operation[]): Operation {
    return operations
      .filter(function (item) {
        return item.workflowId == 1;
      }).map(function (item) {
        return item;
      })
      .sort((opA: Operation, opB: Operation) => (opA.id > opB.id ? -1 : 1))[0]
  }

  private updateAgentEnrollment() {
    this.updatePersonUseCase.execute(
      {
        personId: this.searchEnrollmentDto.personId,
        typePersonUpdate: TypePersonUpdate.PERSON_UPDATE,
        metadata: this.buildMetadata()
      }
    ).subscribe(updateResponse => {
      this.closeLoader()
      console.log("Search enrollmente success, showing data...")

      this.handleResponseData(
        updateResponse,
        {
          titleMessage: "Modificación de datos",
          bodyMessage: "Se ha finalizado el proceso, continua tu tramite",
          onAcceptSuccess: () => {
            this.updateDataEnrollment()
          }
        }
      )
    }, error => {
      this.closeLoader()
      console.log("Search enrollmente error: " + error.message)
      this.presentAlert(
        'Aviso',
        error.message,
        false
      );
    })
  }

  private updateDataEnrollment() {
    var _this = this;
    this.showLoading()
    this.searchEnrollmentUseCase.execute(
      {
        dataToSearch: this.searchEnrollmentDto.dataSearched,
        typeSearchingBy: this.searchEnrollmentDto.typeSearchingBy,
        metadata: this.buildMetadata()
      }
    ).subscribe(searchResponse => {
   
      this.closeLoader()
      this.handleResponseDataNoMessage(
        searchResponse,
        () => {
          searchResponse.data.typeSearchingBy = this.searchEnrollmentDto.typeSearchingBy;
          searchResponse.data.dataSearched = this.searchEnrollmentDto.dataSearched;
          _this.searchState.value$ = searchResponse.data;
        }
      )
    }, error => {
      this.closeLoader()
      console.log("Search enrollmente error: " + error.message)
    })
  }

  private async presentAlertAgentEnrollment() {
    this.presentAlert(
      "Modificación de datos",
      "Se actualizará el agente del registro del cliente. ¿Desea continuar?",
      true,
      () => {
        this.updateAgentEnrollment()
      }
    )
  }

  get name() {
    return this.resultForm.get('name');
  }
  get email() {
    return this.resultForm.get('email');
  }
  get curp() {
    return this.resultForm.get('curp');
  }
  get rfc() {
    return this.resultForm.get('rfc');
  }
  get birthDay() {
    return this.resultForm.get('birthDay');
  }
  get agent() {
    return this.resultForm.get('agent');
  }
  get sucursal() {
    return this.resultForm.get('sucursal');
  }

}
